<!-- Hero Section -->
<header class="bg-primary text-white text-center py-5">
  <div class="container">
    <h1 class="display-4">Welcome to HMC IT Network Services</h1>
    <p class="lead">Your Trusted Partner for IT Solutions, Networking, and Security</p>
    <a [routerLink]="'/service'" class="btn btn-light btn-lg">Explore Our Services</a>
  </div>
</header>

<app-about></app-about>

<!-- Services Section -->
<section class="py-5 bg-dark text-center">
  <div class="container">
    <h2 class="text-light fw-bold mb-4">Our Expertise</h2>
    <div class="row g-4">
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 shadow-sm border-0">
          <img src="assets/img/Services/cctv.jpg" class="card-img-top" alt="CCTV Installation">
          <div class="card-body">
            <h5 class="card-title text-dark">CCTV Installation</h5>
            <p class="card-text text-muted">Secure your premises with state-of-the-art surveillance solutions for peace of mind.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 shadow-sm border-0">
          <img src="assets/img/Services/structural_cabling.jpg" class="card-img-top" alt="Networking Solutions">
          <div class="card-body">
            <h5 class="card-title text-dark">Networking Solutions</h5>
            <p class="card-text text-muted">Robust and reliable networking infrastructure to keep your business connected.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 shadow-sm border-0">
          <img src="assets/img/Services/dm.png" class="card-img-top" alt="Digital Marketing">
          <div class="card-body">
            <h5 class="card-title text-dark">Digital Marketing</h5>
            <p class="card-text text-muted">Boost your online presence with our tailored marketing strategies.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Testimonials Section -->
<section class="bg-light py-5">
  <div class="container">
    <h2 class="text-center text-primary mb-4">What Our Clients Say</h2>
    <div id="testimonialsCarousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="text-center">
            <img src="assets/img/Clients/client.png" class="rounded-circle mb-3" alt="Client 1">
            <blockquote class="blockquote">
              <p class="mb-0">"HMC IT transformed our network infrastructure, enhancing speed and reliability. We trust them for all our IT needs!"</p>
              <footer class="blockquote-footer">John Doe, <cite title="Source Title">TechCorp</cite></footer>
            </blockquote>
          </div>
        </div>
        <div class="carousel-item">
          <div class="text-center">
            <img src="assets/img/Clients/client.png" class="rounded-circle mb-3" alt="Client 1">
            <blockquote class="blockquote">
              <p class="mb-0">"Their digital marketing team helped us reach new customers. Our online presence has never been stronger!"</p>
              <footer class="blockquote-footer">Jane Smith, <cite title="Source Title">BizSolutions</cite></footer>
            </blockquote>
          </div>
        </div>
        <div class="carousel-item">
          <div class="text-center">
            <img src="assets/img/Clients/client.png" class="rounded-circle mb-3" alt="Client 1">

            <blockquote class="blockquote">
              <p class="mb-0">"The CCTV system they installed has given us peace of mind. Professional service and high-quality equipment!"</p>
              <footer class="blockquote-footer">Michael Lee, <cite title="Source Title">RetailInc</cite></footer>
            </blockquote>
          </div>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#testimonialsCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#testimonialsCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</section>

<!-- Contact Section -->
<section class="py-5 bg-primary text-white text-center">
  <div class="container">
    <h2 class="fw-bold mb-4">Get in Touch</h2>
    <p class="lead">Have any questions or need help? Feel free to contact us!</p>
    <a [routerLink]="'/contact'" class="btn btn-light btn-lg">Contact Us</a>
  </div>
</section>
